<div class="wrapper-landing-business-page">
  <div class="zc-container">
    <div class="header-business-page">
      <div class="header-business-page-content">
        <span class="header-title-business-page">Povećajte vidljivost i poslujte bez naknade</span>
        <span class="header-subtitle-business-page">Pridružite se aplikaciji <b>Moj Rođendan</b> i postanite deo najveće platforme za organizaciju dečijih proslava u Srbiji! <br>
Budite vidljivi hiljadama roditelja koji svakodnevno traže igraonice, torte, ketering, fotografe, animatore i dekoraciju — baš poput vaše usluge.
Naša misija je jednostavna: da povežemo vas sa roditeljima koji već planiraju rođendan.
Kroz besplatnu registraciju dobijate svoj profil u aplikaciji, mogućnost direktnih rezervacija, sigurnu naplatu i automatske potvrde termina.
Minimalna provizija. Bez dodatnih troškova. Samo novi klijenti i više posla. <br>
<b>Pridružite se danas i postanite deo priče koja menja način na koji se organizuju dečiji rođendani!</b>
</span>
        <button [routerLink]="[PAGES_AND_PATHS.landingContact.pagePath]" [state]="{isBusiness: true}" class="custom-btn custom-btn--white">
          <span>Postanite partner</span>
        </button>
        <div class="wrapper-business-categories">
          <div class="wrapper-tag-category">
            <span>Dekoracija</span>
          </div>
          <div class="wrapper-tag-category">
            <span>Pokloni</span>
          </div>
          <div class="wrapper-tag-category">
            <span>Ketering</span>
          </div>
          <div class="wrapper-tag-category">
            <span>Igraoinice</span>
          </div>
          <div class="wrapper-tag-category">
            <span>Torte</span>
          </div>
          <div class="wrapper-tag-category">
            <span>Fotografi</span>
          </div>
          <div class="wrapper-tag-category">
            <span>Animatori</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="zc-container">
    <div class="grid">
      <div class="grid__s-12">
        <div class="three-steps-home">
          <div class="wrapper-home-steps">
            <div class="home-step">
              <img src="../../../../assets/images/landing/business/business-step1-illustration.svg" alt="">
              <h4>Registruj nalog</h4>
              <p>Prvi korak ka većem broju klijenata! <br>
                Kreirajte svoj besplatni nalog u aplikaciji Moj Rođendan i predstavite svoj biznis hiljadama roditelja koji svakodnevno traže igraonice, ketering, torte, fotografe, dekoracije i animatore.</p>
            </div>
            <img class="line-step-home business-step1" src="../../../../assets/images/landing/line-step.svg" alt="">
            <div class="home-step">
              <img src="../../../../assets/images/landing/business/business-step2-illustration.svg" alt="">
              <h4>Popuni termine</h4>
              <p>Unesite svoje slobodne termine i usluge — aplikacija automatski prikazuje dostupnost roditeljima u realnom vremenu.
                <br>
                Bez poziva, bez dopisivanja, bez grešaka. Vi definišete cene, trajanje i uslove, a korisnici rezervišu direktno kroz aplikaciju.</p>
            </div>
            <img class="line-step-home business-step2" src="../../../../assets/images/landing/line-step.svg" alt="">
            <div class="home-step">
              <img src="../../../../assets/images/landing/business/business-step3-illustration.svg" alt="">
              <h4>Posluj sa zadovoljstvom</h4>
              <p>Svaka rezervacija se automatski potvrđuje i beleži u vašem profilu, a uplata je sigurna i transparentna.
                <br>
                Vi pružate uslugu, roditelji dobijaju potvrdu — a svi zajedno stvarate nezaboravne rođendane. br
                Jednostavno, jasno i bez stresa.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  -->
  <div class="wrapper-three-step-description">
    <div class="zc-container">
      <div class="grid bg-white-three-step xs-mb-120">
        <div class="grid__llx-6">
          <div class="wrapper-content-step-desc">
            <!--            bez finansijskih obaveza i naknada-->
            <h1>Besplatna aplikacija za korišćenje</h1>
            <p>Registracija i korišćenje aplikacije Moj Rođendan su u potpunosti besplatni za biznis korisnike.
              Nema mesečnih troškova, skrivenih provizija ni ugovornih obaveza.
              Jednostavno kreirate nalog, popunite ponudu svojih usluga i odmah postajete vidljivi hiljadama roditelja koji svakodnevno planiraju proslave.
              Kroz aplikaciju dobijate svoj profil, mogućnost direktnih rezervacija, automatsku evidenciju termina i sigurnu naplatu.
              <br>
            <button [routerLink]="[PAGES_AND_PATHS.landingContact.pagePath]" class="custom-btn custom-btn--purple xs-mt-20 xs-mb-20 xl-mb-0">
              <span>Registruj se</span>
            </button>
          </div>
        </div>
        <div class="grid__llx-6 wrapper-image-step-col">
          <div class="wrapper-image-three-step">
            <img src="../../../../assets/images/landing/illustration-step1-desc.svg" alt="">
          </div>
        </div>
      </div>
      <div class="grid bg-white-three-step two xs-mb-120">
        <div class="grid__llx-6 wrapper-image-step-col">
          <div class="wrapper-image-three-step">
            <img src="../../../../assets/images/landing/illustration-step2-desc.svg" alt="">
          </div>
        </div>
        <div class="grid__llx-6">
          <div class="wrapper-content-step-desc">
            <h1>Višestruko povećajte svoju vidljivost među roditeljima</h1>
            <p>Budite tamo gde vas roditelji traže!
              Kao partner aplikacije <b>Moj Rođendan</b>, vaš biznis postaje vidljiv hiljadama korisnika koji svakodnevno planiraju dečije proslave – igraonice, torte, ketering, fotografe, animatore, dekoracije i poklone.
              Vaša ponuda, cene i slobodni termini prikazuju se direktno u aplikaciji, što znači da vas klijenti pronalaze i rezervišu bez poziva i posrednika.
              <br>
            <button [routerLink]="[PAGES_AND_PATHS.landingContact.pagePath]" class="custom-btn custom-btn--purple xs-mt-20 xs-mb-20 xl-mb-0">
              <span>Povećaj vidljivost</span>
            </button>
          </div>
        </div>
      </div>
      <div class="grid bg-white-three-step">
        <div class="grid__llx-6">
          <div class="wrapper-content-step-desc">
            <h1>Sve rezervacije i termini — na jednom mestu</h1>
            <p>Zaboravite na haotične rokovnike, exel tabele, viber grupe, prepiske i pogrešne termine.
              Kroz aplikaciju <b>Moj Rođendan</b> pratite sve rezervacije i usluge u realnom vremenu – jasno, pregledno i dostupno u svakom trenutku.
              Svaka potvrda o rezervaciji automatski stiže na vaš mejl, zajedno sa svim podacima o klijentu, datumu, trajanju i iznosu.
              Na taj način imate potpunu kontrolu nad poslovanjem, a sve promene se beleže automatski. <br>
<!--              <i>Sve pod kontrolom, uvek i svuda.</i>-->
            </p><br>
            <button [routerLink]="[PAGES_AND_PATHS.landingContact.pagePath]" class="custom-btn custom-btn--purple xs-mb-20 xl--mb-0">
              <span>Pogledajte kako funkcioniše</span>
            </button>
          </div>
        </div>
        <div class="grid__llx-6 wrapper-image-step-col">
          <div class="wrapper-image-three-step">
            <img src="../../../../assets/images/landing/illustration-step3-desc.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  Largest business partners section -->
  <div class="wrapper-business-partner">
    <div class="bg-image-partners"></div>
    <div class="zc-container">
      <div class="wrapper_largest_business_partners">
        <div class="wrapper-icon-slider-business-partner">
          <img src="../../../../assets/icons/landing/icon-star-blue.svg" alt="">
        </div>
        <div class="wrapper-icon-slider-business-partner-red">
          <img src="../../../../assets/icons/landing/icon-star-blue.svg" alt="">
        </div>
        <div class="grid">
          <div class="grid__s-12">
            <span class="small-title">Naši biznis partneri</span>
          </div>
        </div>
        <div class="grid">
          <div *ngFor="let partner of businessPartners" class="grid__m-4">
            <a *ngIf="banners.F?.length && banners.F[partner]" [href]="banners.F[partner].link" target="_blank">
              <div class="wrapper-banner-image-largest-business">
                <img [src]="banners.F[partner].image.full_path" alt="">
              </div>
            </a>
            <div *ngIf="!banners.F?.length || !banners.F[partner]" class="wrapper-banner-empty">
              <img class="yellow-icon-banner" src="../../../../assets/icons/landing/illustration/illustration-yellow-empty-banner.svg" alt="">
              <img class="r-empty-banner" src="../../../../assets/icons/landing/illustration/illustration-r-empty-banner.svg" alt="">
              <div class="content-empty-banner">
                <img src="../../../../assets/icons/landing/illustration/white-r.svg" alt="">
                <span>Mesto za</span>
                <span><b>Vašu reklamu!</b></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- FAQ section -->
  <div class="wrapper-faq-section">
    <div class="zc-container">
      <div class="grid">
        <div class="grid__s-12">
          <div class="wrapper-faq">
            <div class="wrapper-title faq">
              <h2>Česta <span>pitanja</span></h2>
              <img src="../../../../assets/icons/landing/illustration/faq-illustration.svg" alt="">
            </div>
            <div class="wrapper-content-faq">
              <div *ngFor="let faq of faqs; index as faqIndex" class="wrapper-question" (click)="faqIndex === activeFaqIndex ? activeFaqIndex = -1 : activeFaqIndex = faqIndex"  [ngClass]="{'collapsed': faqIndex === activeFaqIndex}">
                <span class="title-question">{{ faq.question }}</span>
                <span class="description-answer">{{ faq.answer }}</span>
                <img class="icon-star-green rotating" src="../../../../assets/icons/landing/icon-star-green.svg" alt="">
                <img class="icon-blue plus" src="../../../../assets/icons/landing/icon-plus-blue.svg" alt="">
                <img class="icon-blue minus" src="../../../../assets/icons/landing/Icon-minus-blue.svg" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Newsletter section -->
  <div class="wrapper-newsletter">
    <span class="title-newsletter">Prijavite se i dobijajte najnovije informacije</span>
    <span class="subtitle-newsletter">Prijavite se i prvi saznajte sve o novim igrama, poklonima i akcijama!</span>
    <form [formGroup]="newsletterForm" (ngSubmit)="onSubmitPostNewsletterForm()" class="form-newsletter">
      <div class="wrapper-input-landing">
        <div class="custom-input">
          <input [formControl]="newsletterForm.controls.email | formControl" type="text" placeholder="">
        </div>
        <span class="error-message">{{newsletterForm.controls.email | formControlErrorMessages: 'Unesite validnu email adresu.' : newsletterFormTriedToSubmit}}</span>
      </div>
      <button type="submit" class="custom-btn custom-btn--purple">
        <span>Pošaljite</span>
      </button>
    </form>
  </div>
</div>
